const DEFAULT_API_URL = 'http://localhost:8000/api';

/**
 * Normalize the public backend base URL.
 *
 * The backend mounts app routes under `/api`. Hosting envs sometimes get set
 * to only the origin (`https://api.prompt-save.com`), which makes every client
 * request hit `/prompts`, `/auth/login`, etc. and return 404. Accept either
 * shape here and always return a base ending in `/api`.
 */
export function getApiBaseUrl(raw = process.env.NEXT_PUBLIC_API_URL): string {
  const base = (raw || DEFAULT_API_URL).trim().replace(/\/+$/, '');
  if (/\/api(?:\/)?$/i.test(base)) return base.replace(/\/+$/, '');
  return `${base}/api`;
}

export function getApiOrigin(raw = process.env.NEXT_PUBLIC_API_URL): string {
  return new URL(getApiBaseUrl(raw)).origin;
}
